<template>
  <b-row>
    <b-col class="pl-3">
      <div class="font-small-3 mb-0">
        Avg Time
      </div>
      <div class="font-weight-bolder mb-0">
        {{ avgPageDuration }}
      </div>
    </b-col>
    <b-col>
      <div class="font-small-3 mb-0">
        Readability
      </div>
      <div class="font-weight-bolder mb-0">
          {{ parseInt(avgReadability) }}
      </div>
    </b-col>
    <b-col>
      <div class="font-small-3 mb-0">
        Recirculation
      </div>
      <div class="font-weight-bolder mb-0">
        {{ avgRecirculation }} %
      </div>
    </b-col>
    <b-col>
      <div class="font-small-3 mb-0">
        Scroll
      </div>
      <div class="font-weight-bolder mb-0">
        {{ avgScrollPercentage }} %
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
    BRow,
    BCol,
} from 'bootstrap-vue'
import { getCoreApiByObjectId, getCoreApiLatestObject } from '@/coreApi/coreApiHelper'

// eslint-disable-next-line import/no-extraneous-dependencies
const moment = require('moment')

export default {
    components: {
        BRow,
        BCol,
    },
    props: {
        dataObject: {
            type: Object,
            default: () => {},
        },
        onProgress: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            avgPageDuration: 0,
            avgReadability: 0,
            avgRecirculation: 0,
            avgScrollPercentage: 0,
        }
    },
    watch: {
        dataObject() {
            const object = getCoreApiByObjectId(this.dataObject, 'statistics')

            let data = null
            if (
                object
                && object.data
                && object.data.at(-1)
            ) {
                data = object.data.at(-1)
            }
            if (data) {
                this.avgPageDuration = moment.utc(data.avgReadabilityPageDuration * 1000).format('mm:ss')
                this.avgReadability = data.avgReadability
                this.avgRecirculation = data.avgRecirculation
                this.avgScrollPercentage = data.avgReadabilityScrollPercentage
            } else {
                this.avgPageDuration = 0
                this.avgReadability = 0
                this.avgRecirculation = 0
                this.avgScrollPercentage = 0
            }
        },
    },
}
</script>
